export const COACHMARK_ANIMATION_DURATION = 150;
export const COACHMARK_ANIMATION_EASING = "cubic-bezier(0.4, 0, 0.2, 1)";
export const COACHMARK_ARROW_SIZE = 8;
export const COACHMARK_OFFSET = 12;
export const COACHMARK_Z_INDEX = 1400;
export const COACHMARK_DISMISS_NAMESPACE = "coachmark-dismissed";
export const COACHMARK_DISMISS_TTL = 365 * 24 * 60 * 60 * 1000;
